import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { TermsView } from '../features/auth/TermsView';
import { useAuthStore } from '../stores/auth';

function TermsPage() {
  const me = useAuthStore((s) => s.me);
  const acceptTerms = useAuthStore((s) => s.acceptTerms);
  const navigate = useNavigate();
  return (
    <TermsView
      needsAcceptance={Boolean(me?.needs_terms)}
      onAccept={async () => {
        await acceptTerms();
        navigate({ to: '/' });
      }}
    />
  );
}

export const Route = createFileRoute('/terms')({ component: TermsPage });
